import { Box, Typography, TextField, Button, Grid } from '@mui/material'
import { useForm } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import { useUtiles } from '../../../shared/context/utilesContext'
import { useEquipment } from '../../../shared/context/equipmentContext'
import { useTheme } from '@mui/material/styles'


export default function CreateTypeEquipmentComponent() {

    const theme = useTheme()
    const { createTypeEquipment, loadingCreateTypeEquipment } = useEquipment()
    const { restorePreviousComponent, setAlertSnackbar } = useUtiles()
    const { control, handleSubmit, formState: { errors }, setValue, watch } = useForm({
        defaultValues: {
            name: '',
        }
    })

    const handleCreateTypeEquipment = async (data) => {
        try {
            await createTypeEquipment({...data})
            
            // Mostrar mensaje de éxito
            setAlertSnackbar({
                open: true,
                message: 'Clasificación creada exitosamente',
                severity: 'success'
            })
            
            // Restaurar el componente anterior
            restorePreviousComponent()
        } catch (error) {
            setAlertSnackbar({
                open: true,
                message: error.message || 'Error al crear la clasificación',
                severity: 'error'
            })
        }
    }



    return (
        <Box sx={{
            padding: '10px',
        }}>
            <form onSubmit={handleSubmit(handleCreateTypeEquipment)}>
                <Grid container spacing={2}>
                    <Grid item size={{ xs: 12, }}>
                    <Controller
                        control={control}
                        name="name"
                        rules={{ required: 'Este campo es requerido' }}
                        render={({ field }) => (
                            <TextField fullWidth placeholder="Nombre" {...field} error={!!errors.name} helperText={errors.name?.message} />
                        )}
                    />
                </Grid>
                <Grid item size={{ xs: 12}}>
                        <Button type="submit" variant="contained" color="primary" disabled={loadingCreateTypeEquipment}>{loadingCreateTypeEquipment ? 'Creando...' : 'Crear'}</Button>
                        <Button 
                            variant="contained" 
                            color="disabled" 
                            sx={{ ml: 1 }}
                            onClick={restorePreviousComponent}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Box>
    )
}